import spinner from './spinner.gif'

const Loader = ({ progress }) => {
    const { loadedItems = 0, totalItems = 0 } = progress;
    const percent = totalItems ? Math.round(loadedItems / totalItems * 100) : 10;

    return (
        <div className="loader">
            <img src={spinner} alt="Loading" />
            <h1>Loading map data</h1>
            <div className="loader-progress">
                <div
                    className="loader-progress-bar"
                    role="progressbar"
                    aria-label="Loading map points"
                    aria-valuemin="0"
                    aria-valuemax={totalItems || 100}
                    aria-valuenow={totalItems ? loadedItems : 10}>
                    <span style={{width: `${percent}%`}} />
                </div>
                <p>{totalItems ? `${loadedItems} of ${totalItems} map points` : 'Loading map points…'}</p>
            </div>
        </div>
    )
}

export default Loader
